import { Borrower, Country, Location, User } from '.';
import { Province } from './common';

export enum LoanType {
  PAYDAY = 'payday',
  RENT = 'rent',
  MORTGAGE = 'mortgage',
  EQUITY_FINANCE = 'equity finance',
}

export enum LoanTypeId {
  MORTGAGE = 1,
  EQUITY_FINANCE = 2,
  RENT = 3,
  PAYDAY = 4,
}

export enum LoanStatus {
  OPEN = 'open',
  UNDERWRITING = 'underwriting',
  ONGOING = 'active',
  CLOSED = 'closed',
}

export enum LoanStatusId {
  OPEN = 1,
  UNDERWRITING = 2,
  ONGOING = 3,
  CLOSED = 4,
}

export interface LoanDto {
  loan_type_id: number;
  loan_detail: {
    name: string;
    amount: number;
    tenure: number;
  };
  mortgage?: {
    purchase_price: number;
    down_payment?: number | null;
    is_new_construction: boolean;
    property: {
      title: string;
      type: string;
      location: Location;
    };
    developer?: {
      name: string;
      location: Location;
    };
    contact_person: {
      name: string;
      phone: string;
      email?: string;
    };
  };
  equity?: {
    estimated_property_value: number;
    valuation_method: string;
    property_address: Location;
  };
  rent?: {
    include_agent_cost: boolean;
    other_cost?: number | null;
    property_address: Location;
    home_owner: {
      name: string;
      phone: string;
      email?: string;
    };
  };
}

export interface LoanFormValues {
  address: string;
  bvn: string;
  city: string;
  contact_email: string;
  contact_name: string;
  contact_phone: string;
  down_payment?: string;
  employer_city: string;
  employer_name: string;
  employment_type: string;
  first_name: string;
  job_title: string;
  last_name: string;
  linkedin: string;
  loan_amount: string;
  loan_tenure: string;
  loan_type: string;
  nin: string;
  occupation: string;
  project_name: string;
  property_address: string;
  property_city: string;
  property_country: string;
  property_state: string;
  property_title: string;
  property_type?: string;
  purchase_price?: string;
  is_new_construction?: boolean;
  state: string;
  property_value?: string;
  valued_method?: string;
  developer_address?: string;
  developer_city?: string;
  developer_country?: string;
  developer_name?: string;
  developer_state?: string;
  home_owners_email?: string;
  home_owners_name?: string;
  home_owners_phone?: string;
  other_cost?: string;
  include_agent_cost?: boolean;
}

export interface Loan {
  id: number;
  user_id: number;
  borrower: Borrower;
  loan_type_id: number;
  loan_status_id: number;
  title: string;
  amount: string;
  tenure: number;
  interest: number;
  offer_tenure: number;
  borrower_country_id: number;
  purchase_price: string;
  down_payment: string;
  is_new_construction: boolean;
  property_title: string;
  property_type: string;
  property_address: string;
  property_city: string;
  property_state_id: number;
  property_country_id: number;
  property_state: Province;
  property_country: Country;
  property_developer_name: string;
  property_developer_address: string;
  property_developer_city: string;
  property_developer_state_id: number;
  property_developer_country_id: number;
  property_developer_country: Country;
  property_developer_state: Province;
  contact_name: string;
  contact_phone: string;
  contact_email: string;
  estimated_property_value: string;
  valuation_method: string;
  owner_name: string;
  owner_phone: string;
  owner_email: string;
  include_agent_cost: boolean;
  other_cost: string;
  created_at: string;
  updated_at: string;
}

export interface LoansPayload {
  data: Loan[];
  total: number;
  page: number;
  last_page: number;
}

export interface LoanPagination {
  page: number;
  total: number;
  last_page: number;
}

// export interface Loan extends Loan {
//   user: User;
//   property_state: State;
//   property_country: PropertyCountry;
//   // property_developer_state: null;
//   // property_developer_country: null;
// }

export enum LoanOfferTabs {
  OFFERS = 'offers',
  REPAYMENTS = 'repayments',
  INFORMATION = 'information',
  TRANSACTIONS = 'transactions',
}

export interface LoanOffer {
  id: number;
  user_id: number;
  status: LoanOfferStatus;
  loan_id: number;
  tenure: number;
  interest: string;
  note: string;
  created_at: string;
  updated_at: string;
  user: User;
  loan: Loan;
}

export interface LoanQueryParams {
  page?: number | null;
  types?: string | null;
  countries?: string | null;
  status?: number | null;
}

export enum LoanOfferStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  CANCELLED = 'CANCELLED',
}

export interface LoanOfferDto {
  tenure: number;
  interest: number;
  loan_id: number;
  note?: string;
}

export interface UpdateLoanOfferDto {
  tenure: number;
  interest: number;
}

export interface UpdateLoanOfferStatusDto {
  note?: string;
  status: LoanOfferStatus;
}

export interface LoanRepayment {
  id: number;
  loan_id: number;
  amount: string;
  due_date: string;
  paid: boolean;
  paid_date: null | string;
  payment_method: null | string;
  created_at: string;
  updated_at: string;
}

export interface LoanTransaction {
  id: number;
  loan_id: number;
  amount: string;
  description: string;
  created_at: string;
  updated_at: string;
}
